import CustomSvgPanZoom from './CustomSvgPanZoom';

export default CustomSvgPanZoom;
